/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { AnafInvoiceCheckStatusEnum, AnafInvoiceUploadStatusEnum } from '@well/delivery-libs/efactura/domain-model';
import { AttachmentSaveLocationType, AttachmentVO } from '@well/attachment/domain';
import { InvoiceListState } from './invoice-list-state.model';

export class InvoiceListVO extends JSONable {
  uuid: string | undefined = undefined;
  invoiceSeries: string | undefined = undefined;
  orderNumber: string | undefined = undefined;
  issueDate: string | undefined = undefined;
  serviceProviderName: string | undefined = undefined;
  serviceProviderCountry: string | undefined = undefined;
  customerName: string | undefined = undefined;
  customerCountry: string | undefined = undefined;x: any
  invoiceStatus: string | undefined = undefined;
  anafInvoiceUploadStatus: AnafInvoiceUploadStatusEnum | undefined = undefined;
  anafInvoiceCheckStatus: AnafInvoiceCheckStatusEnum | undefined = undefined;
  anafInvoiceStatus: string | undefined = undefined;
  anafUploadId: string | undefined = undefined;
  anafDownloadId: string | undefined = undefined;
  anafErrorMessage: string | undefined = undefined;
  anafZipFileUuid: string | undefined = undefined;
  anafPdfFileUuid: string | undefined = undefined;
  currencyCode: string | undefined = undefined;
  localCurrencyCode: string | undefined = undefined;
  totalPrice: number | undefined = undefined;
  localTotalPrice: number | undefined = undefined;
  netPrice: number | undefined = undefined;
  paymentStatus: string | undefined = undefined;
  invoiceType: string | undefined = undefined;
  paymentTimeLimit: string | undefined = undefined;
  paymentDueDate: string | undefined = undefined;
  agreedPaymentDate: string | undefined = undefined;
  customPaymentAgreement: boolean | undefined = undefined;
  invoiceFileStoreUuid: string | undefined = undefined
  attachmentSaveLocation: AttachmentSaveLocationType | undefined = undefined;
  canceledInvoiceUuid: string | undefined = undefined;
  finalPaymentDueDate: string | undefined = undefined;
  attachmentVos: AttachmentVO[] = [];
  invoiceGenerationType: string | undefined = undefined;
  balance: number | undefined = undefined;
  balanceCurrencyCode: string | undefined = undefined;
  ordersTotalCost: number | undefined = undefined;
  ordersPaymentTimeLimit: number | undefined = undefined;
  createdBy: string | undefined = undefined;
  createdAt: string | undefined = undefined;
  allowedPaymentsInCurrencies: string[] = [];
  state: InvoiceListState | undefined = undefined;
}
